function readEnv(key: keyof ImportMetaEnv, fallback = ""): string {
  const value = import.meta.env[key];
  if (value == null || String(value).includes("%VITE_")) return fallback;
  return String(value);
}

function readApiBaseUrl(): string {
  const value = import.meta.env.VITE_API_BASE_URL;
  // Empty string = same-origin (production Docker / gateway). Only fall back
  // to localhost when the var is truly unset (local Vite without .env).
  if (value === "") return "";
  if (value == null || String(value).includes("%VITE_")) {
    return "http://127.0.0.1:8080";
  }
  return String(value).replace(/\/$/, "");
}

export const env = {
  appName: readEnv("VITE_APP_NAME", "Papaya Web"),
  apiBaseUrl: readApiBaseUrl(),
  debug: readEnv("VITE_DEBUG_MODE", "true") === "true",
  firebase: {
    apiKey: readEnv("VITE_FIREBASE_API_KEY"),
    authDomain: readEnv(
      "VITE_FIREBASE_AUTH_DOMAIN",
      readEnv("VITE_FIREBASE_PROJECT_ID")
        ? `${readEnv("VITE_FIREBASE_PROJECT_ID")}.firebaseapp.com`
        : "",
    ),
    projectId: readEnv("VITE_FIREBASE_PROJECT_ID"),
    storageBucket: readEnv("VITE_FIREBASE_STORAGE_BUCKET"),
    messagingSenderId: readEnv("VITE_FIREBASE_MESSAGING_SENDER_ID"),
    appId: readEnv("VITE_FIREBASE_APP_ID"),
    vapidKey: readEnv("VITE_FIREBASE_VAPID_KEY"),
  },
} as const;
